import { createAsyncThunk } from "@reduxjs/toolkit";
import ordersService from "../../../api/services/orders";

export const createOrder = createAsyncThunk(
  "orders/createOrder",
  async (orderData) => {
    return await ordersService.createOrder(orderData);
  }
);

export const getUserOrders = createAsyncThunk(
  "orders/getUserOrders",
  async ({ page = 1, limit = 10 } = {}) => {
    return await ordersService.getUserOrders(page, limit);
  }
);

export const getOrderById = createAsyncThunk(
  "orders/getOrderById",
  async (orderId) => {
    return await ordersService.getOrderById(orderId);
  }
);

// Admin functions
export const getAllOrders = createAsyncThunk(
  "orders/getAllOrders",
  async ({ page = 1, limit = 10, filters = {}, search = "" } = {}) => {
    return await ordersService.getAllOrders(page, limit, filters, search);
  }
);

export const updateOrderStatus = createAsyncThunk(
  "orders/updateOrderStatus",
  async ({ orderId, status }) => {
    return await ordersService.updateOrderStatus(orderId, status);
  }
);

export const addTrackingNumber = createAsyncThunk(
  "orders/addTrackingNumber",
  async ({ orderId, trackingNumber }) => {
    return await ordersService.addTrackingNumber(orderId, trackingNumber);
  }
);

export const getOrderStatistics = createAsyncThunk(
  "orders/getOrderStatistics",
  async () => {
    return await ordersService.getOrderStatistics();
  }
);